export const songMenuOverlay = `
<div class="m-loadOverlay screen-overlay">
	<div class="mlo-infoDiv">
		<h1 class="mlo-title">Welcome to RecorderAce</h1>
		<div class="mlo-status">Loading songs and team data...<div>
	</div>
</div>
`;

export const songMenuContainer = `
<div id="m-container">
	
	<div id="m-header">
		<a id="m-homePageLink" href="https://playrecorder.com" target="blank">
			PlayRecorder.com
		</a>
	</div>
	
	<div id="m-pageInfo">
		<div id="m-description">
			<h2>Master music challenges with RecorderAce!</h2>
			<h5>Practice Recorder Karate and other fun recorder songs. Connect
				your microphone to go for a perfect score! And new in RecorderAce 2.0,
				team up with other students in your class and find out which class
				can earn the most points on the worldwide leaderboard each week!
			</h5>
		</div>
	</div>
	
	<div id="m-currentStudent">
		<div id="m-currentStudent-welcome">
		</div>
		<div class="m-currentStudent-changeDiv">
			<a id="m-switchUserLink">Switch User</a>
		</div>
	</div>
	
	<div id="m-library" class="m-pageSection">				
		<div class="m-panel-section">
			<div class="m-grid-section-header">
				<div class="m-panel-section-header-graphic">
					<img src="{{r}}images/songMenuScreen/magnifyingGlass.png" alt="Songs"/>
				</div>
				<div class="m-panel-section-header-title">Music Challenges</div>
			</div>
			<div class="m-panel-content">
				<div class="m-panel-sidebar">
					<div class="m-sidebar-sectionHeader">Categories</div>
					<div class="m-sidebar-genresDiv">
					</div>
				</div>
				<div class="m-panel-songsAndNav">
					<div class="m-hpanel">
					</div>
					<div class="m-hpanelnav">
						<a class="m-previousResults"><div></div></a>
						<a class="m-nextResults"><div></div></a>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div id="m-leaders" class="m-pageSection">
		<div class="m-grid-section-header">
			<div class="m-panel-section-header-graphic">
				<img src="{{r}}images/songMenuScreen/fire.png" alt="Leaders"/>
			</div>
			<div class="m-panel-section-header-title">Team Leaderboard:</div>
		</div>
		<div class="m-leaders-description">
			<div class="m-leaders-description-this-week">
				Weekly Leaders - New contests begin every Monday -
				<a class="m-leaders-toggle-week">See last week's results.</a>
			</div>
			<div class="m-leaders-description-last-week hide">
				Last Week's Results -
				<a class="m-leaders-toggle-week">See current week.</a>
			</div>
		</div>
		<div class="m-leaders-list"></div>
	</div>
</div>
`;

export const sidebarItem = `
<div class="m-sidebar-item"></div>
`;

export const songItem = `
<div class="m-songItem">
	<div class="m-songItem-scoreContainer">
		<div class="m-songItem-scoreDiv"></div>
	</div>
	<div class="m-songItem-infoDiv">
		<div class="m-title"></div>
	</div>
</div>
`;

export const leaderboardItem = `
<div class="m-leaders-leaderItem"></div>
`;